import { Controller } from "stimulus"

const CLASS_OPEN = 'is-item-open';

export default class extends Controller {
    opened = false;
    resizeTimer = null;

    static targets = ["body", "content"];

    initialize() {
        this.onResize = this.onResize.bind(this);
        this.tick = this.tick.bind(this);
    }

    connect() {
        window.addEventListener("load", this.tick);
        window.addEventListener("resize", this.onResize);
    }

    onResize() {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(this.tick, 100);
    }

    tick() {
        const rect = this.contentTarget.getBoundingClientRect();
        console.log(rect.height);
        this.bodyTarget.style.height = `${rect.height}px`;
    }

    toggle() {
        if (this.opened) {
            this.opened = false;
            this.element.classList.remove(CLASS_OPEN);
        } else {
            this.opened = true;
            this.element.classList.add(CLASS_OPEN);
        }
    }
}


// WEBPACK FOOTER //
// ./mysite/resources/js/controllers/accordion_controller.js